import { render, staticRenderFns } from "./CourseDop.vue?vue&type=template&id=72b86f6e&scoped=true&"
import script from "./CourseDop.vue?vue&type=script&lang=js&"
export * from "./CourseDop.vue?vue&type=script&lang=js&"
import style0 from "./CourseDop.vue?vue&type=style&index=0&id=72b86f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b86f6e",
  null
  
)

export default component.exports